import { bchatRetry } from "@missionlabs/smartagent-bchat";
import { persistanceManager } from "services/persistanceManager";
import listenToLoaderMessages, { setChatLoaderWebsocket } from "store/middleware/chat/loaderListener";
import { getUrlParameters } from "utils";
import { IChatSessionParams } from './chatSession';
import * as Logger from 'services/logger';

const createChatSession = async (
    {
        ws,
        connectionDetails,
        store,
        restoreSession,
        globalRestoreSession,
        attachmentsEnabled,
        startDisconnectChatFlow,
        previousChatId,
        previousAttributes,
    }: IChatSessionParams
): Promise<connect.CustomerChatSession | undefined> => {
    const { contactFlowId, instanceId, attributes, customerDisconnectFlowId } = connectionDetails

    const { setPersistanceContactId, setPersistenceAttachmentIds } = persistanceManager(
        contactFlowId,
        globalRestoreSession
    );
        //
    try {

        const { contactId, participantId, participantToken, region } = await ws.startChatSession({
            attributes: {
                ...previousAttributes, // These will only exist in case of previousChatId
                ...attributes,
                'sa-chat-flow-id': getUrlParameters().chatFlowId,
                'sa-original-contact-id': previousChatId!
            },
            contactFlowId:
                !!startDisconnectChatFlow && !!customerDisconnectFlowId
                    ? customerDisconnectFlowId
                    : contactFlowId,
            instanceId,
            displayName: 'Customer',
        });

        // for file uploads
        await ws.updateContact({
            attributes: {
                'sa-participant-ID': participantId,
            },
            contactId,
        });

        const session = connect.ChatSession.create({
            chatDetails: {
                contactId,
                participantId,
                participantToken,
            },
            type: connect.ChatSession.SessionTypes.CUSTOMER,
            options: {
                region,
            },
        });

        await bchatRetry(async () => await session.connect(), (timesRetried, error) => {
            Logger.warn(`Session.connect retried. Times: ${timesRetried}`, error)
        }).catch(async err => {
            await window.bchat.putMetric({ metricName: 'Error/Connect/RetryFailed' })
            throw err
        });

        if (restoreSession || globalRestoreSession) {
            setPersistanceContactId(contactId);
        }
        if (attachmentsEnabled) {
            setPersistenceAttachmentIds(contactId);
        }
        setChatLoaderWebsocket(ws);
        listenToLoaderMessages(store);
        
        return session;
    } catch (error) {
        console.error('error creating chat session:', error);
        Logger.error('Error creating chat session:', error);
        return;
    }
};

export default createChatSession